export default "/assets/website/images/cart_empty_icon.svg?59140b81f75a22bf4968e6bdc7fdc4d8";